import React, { useRef, useState } from "react"
import { Menu } from "primereact/menu"
import SelectButton from "../../../../components/atoms/SelectButton.atom"
import { TEAM_VACATION_REQUESTS_FILTER_OPTIONS } from "../../../../consts/modules/vacations.consts"

const TeamMemberVacationsMobileHeader = ({
  componentToShow,
  setComponentToShow,
  selectedFilter,
  setSelectedFilter,
  vacationRequests,
}) => {
  const selectOptions = [`Summary`, `Calendar`]

  const sortPanelRef = useRef(null)
  const iElement = document.querySelector(".mobile-vacations-filter-icon")

  const hasFilter =
    TEAM_VACATION_REQUESTS_FILTER_OPTIONS.past_requests !==
      selectedFilter.past_requests ||
    TEAM_VACATION_REQUESTS_FILTER_OPTIONS.rejected_requests !==
      selectedFilter.rejected_requests

  const menuItems = [
    {
      label:
        selectedFilter.past_requests ? "Ocultar pasadas" : "Mostrar pasadas",
      command: () =>
        setSelectedFilter((prev) => ({
          ...prev,
          past_requests: !prev.past_requests,
        })),
    },
    {
      label:
        selectedFilter.rejected_requests ? "Ocultar rechazadas" : (
          "Mostrar rechazadas"
        ),
      command: () =>
        setSelectedFilter((prev) => ({
          ...prev,
          rejected_requests: !prev.rejected_requests,
        })),
    },
  ]

  return (
    <>
      <div className="flex flex-column gap-3">
        <div className="flex justify-content-between align-items-center relative">
          <h2 className="text-xll m-0 font-cairo">Solicitudes</h2>
          <div className="flex gap-4 align-items-center relative">
            <SelectButton
              value={componentToShow}
              options={selectOptions}
              className="vacations-mobile-select-buttons-container"
              itemTemplate={(el) => {
                const isPrev = el.includes("Summary")
                return (
                  <i className={`pi ${isPrev ? "pi-list" : "pi-calendar"}`} />
                )
              }}
              onChange={(e) => {
                if (!e.value) return
                if (componentToShow === selectOptions[0]) {
                  setComponentToShow(selectOptions[1])
                } else {
                  setComponentToShow(selectOptions[0])
                }
              }}
            />
            <i
              className={`pi pi-filter${hasFilter ? "-fill" : ""} cursor-pointer ${
                vacationRequests.length === 0 && "p-disabled"
              } mobile-vacations-filter-icon`}
              onClick={(event) => sortPanelRef.current.toggle(event)}
            />
          </div>
        </div>
      </div>
      <Menu
        model={menuItems}
        popup
        ref={sortPanelRef}
        className="mobile-custom-sort-overlay-panel"
        appendTo={"self"}
      />
    </>
  )
}

export default TeamMemberVacationsMobileHeader
